<template>
    <div v-if="authToken" class="app-background">
        <div class="background-wrapper">
            <VImg v-for="(bg, index) in backgrounds" :key="bg.id" :src="bg.src" class="background-image"
                :class="{ active: bg.active }" :style="backgroundStyle" cover height="100vh" />
            <div class="overlay"></div>
        </div>
    </div>

    <div v-if="authToken" class="content-overlay">
        <SecureAppBar />
        <SecureNavDrawer v-if="store.layoutVertical" />
        <ThemeDrawer />

        <VMain style="--v-layout-top: 0px;" class="my-16 main-content">
            <div class="d-flex flex-column fill-height align-center">

                <div class="flex-grow-1"></div>
                <VContainer :class="!store.layoutVertical ? 'mt-12' : 'mt-4'">
                    <Breadcrumbs />

                    <VerifyAccount class="mb-8" />

                    <NuxtPage />
                </VContainer>
                <div class="flex-grow-1"></div>

            </div>
        </VMain>

        <SecureAppFooter />
    </div>
</template>

<script setup lang="ts">
import { useAppStore } from '@S/appStore';
import { useAppLink } from '@S/appLink';
import { useUserDataStore } from '@S/userDataStore';
import { useDashDataStore } from '@S/dashDataStore';
const { authToken, setAuthToken } = useACookie();

let dashDataStore = useDashDataStore();
let store = useAppStore();
let link = useAppLink();
let userDataStore = useUserDataStore();

if (authToken.value) {
    await userDataStore.fetchUserData(authToken.value);
} else {
    setAuthToken(null);
    store.isAuthenticated = null;
    userDataStore.resetUserData();
    dashDataStore.resetDashData();

    navigateTo('/auth/login')
}


if (store.layoutVertical === false) {
    link.secureMainDrawer = false;
};
if (store.layoutVertical === true) {
    link.secureMainDrawer = true;
};




const totalFiles = 17;
const backgrounds = ref<{ id: number, src: string, active: boolean }[]>([]);
let imageId = 0;
let lastActiveId: number | null = null;

function getRandomBackgroundPath() {
    const index = Math.floor(Math.random() * totalFiles);
    return `/assets/images/dashboard/background${index}.webp`;
}

function preloadAndCrossfade() {
    const nextSrc = getRandomBackgroundPath();
    const img = new Image();

    img.onload = () => {
        const newImage = {
            id: ++imageId,
            src: nextSrc,
            active: false
        };

        backgrounds.value.push(newImage);

        requestAnimationFrame(() => {
            // Activate new image (fade in)
            newImage.active = true;

            // Deactivate old image (fade out)
            if (lastActiveId !== null) {
                const last = backgrounds.value.find(bg => bg.id === lastActiveId);
                if (last) last.active = false;
            }

            lastActiveId = newImage.id;

            // Remove the previous one after fade duration (match CSS)
            setTimeout(() => {
                backgrounds.value = backgrounds.value.filter(bg => bg.id === newImage.id);
            }, 1600); // 100ms buffer over 1.5s fade
        });
    };

    img.src = nextSrc;
}

onMounted(() => {
    const first = {
        id: ++imageId,
        src: getRandomBackgroundPath(),
        active: true
    };
    lastActiveId = first.id;
    backgrounds.value.push(first);

    setInterval(preloadAndCrossfade, 65536);
});




const backgroundStyle = computed(() => store.deviceType === 'Desktop' ? 'filter: blur(4px);' : '');
</script>

<style scoped>
/* Overlay sits above both background images */
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(var(--v-theme-background), 0.75);
    pointer-events: none;
}

.app-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.content-overlay {
    position: relative;
    z-index: 3;
    /* Ensure content stays on top */
}

.main-content {
    min-height: calc(100vh - 64px);
}

.background-wrapper {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.background-image {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: opacity 1.5s ease-in-out;
    pointer-events: none;
    will-change: opacity;
    z-index: 0;
}

.background-image.active {
    opacity: 1;
    z-index: 1;
}








/*.v-footer {
    width: 100%;
}*/
</style>